import { render, staticRenderFns } from "./SignatureLoader.vue?vue&type=template&id=1ddd70eb&scoped=true&"
import script from "./SignatureLoader.vue?vue&type=script&lang=js&"
export * from "./SignatureLoader.vue?vue&type=script&lang=js&"
import style0 from "./SignatureLoader.vue?vue&type=style&index=0&id=1ddd70eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd70eb",
  null
  
)

export default component.exports